module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAjVBMVEUAAAAHBwcJCQkLUaEOU6IPVKIQVKMSVqQYFAIoZawqKSUqKiosaK4uaq81LAVPe5dVhr1ZiL9bW1tdjMFfTwhhYWFufmpxhHNzlq+IqtGLi4uMrdORsdWSkpKYfg2Zhzq3zOO7u7y8z+W/0ebBwcLDoRHGx8fZ3uXZ3+fg2bHivBTxyh/1yxX3zRb80RYbIWKhAAAAkUlEQVR42o3KRxKCQBAAwAFBcgbJOaf9//OkLOVkzU6fGx5E/6IkEaPrEmPT0KI2TRopplGUUqK8iOIiE6JXApQeIXYGgNHxoznAZTC5MfchDMHPefE5C/Zx2ML85MQgUzfGNjULOLHXR3YZ9R6PVluxj6q10FjU7KsusKis5y+eq4LEZGe3PUGiE79usYNExBuQIhdF/jky1gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/lc.png
// module id = 868
// module chunks = 0